/* eslint-disable no-use-before-define */
import { MemoryStorage } from './memoryStorageClass';
import { engine$, Storage } from './Storage';

export const sessionStorage = new Storage(
    engine$(
        () => window.sessionStorage,
        /* istanbul ignore next */
        () => new MemoryStorage(),
    ),
);
